import { OnboardingStep } from '@features/onboarding/models/onboarding-step.models'

export const STEPS: OnboardingStep[] = [
  {
    stepNumber: 1,
    title: 'MTR_ONBOARDING_STEP_1',
    image: 'assets/images/onboarding/step-1.png'
  },
  {
    stepNumber: 2,
    title: 'MTR_ONBOARDING_STEP_2',
    image: 'assets/images/onboarding/step-2.png'
  },
  {
    stepNumber: 3,
    title: 'MTR_ONBOARDING_STEP_3',
    image: 'assets/images/onboarding/step-3.png'
  },
  {
    stepNumber: 4,
    title: 'MTR_ONBOARDING_STEP_4',
    image: 'assets/images/onboarding/step-4.png'
  },
  {
    stepNumber: 5,
    title: 'MTR_ONBOARDING_STEP_5',
    image: 'assets/images/onboarding/step-5.png'
  },
  {
    stepNumber: 6,
    title: 'MTR_ONBOARDING_STEP_6',
    image: 'assets/images/onboarding/step-6.png'
  }
]
